export const environment = {
  production: true,
  environment: 'dev',
  api_url: 'https://api.dev.lab.thelabrador.co.uk/bus/v1/',
  magicLink_url: 'https://api.dev.lab.thelabrador.co.uk/link/',
  contact_api_url: 'https://api.dev.lab.thelabrador.co.uk/v1/',
  labrador_email: "noreply-dev-business@labrador.co.uk",
  dashboard_url: 'https://dashboard.dev.thelabrador.co.uk/home',
  login_link: 'http://localhost:4200/login',
  googleTagManagerId: 'GTM-TDJ6NQS',
  client: 'labrador',
  company_logo: "https://assets.thelabrador.co.uk/email-assets/perswitch1.png",
  new_api_url: 'https://api.dev.lab.thelabrador.co.uk/energytest/v1/',
  module: 'BUSINESS',
  enc_version: 'U2FsdGVkX1822QSYaw7ipQadMskEG6emEEQeemR/7XU='
};

export const jwt = {
  authorizeURL: 'https://api.dev.lab.thelabrador.co.uk/oauth/authorize',
};
